import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const activityTableAnalytics = new AnalyticsService("Activity Table");

export const activityListViewAnalytics = new AnalyticsService("Activity List");

export const smartPlannerViewAnalytics = new AnalyticsService("Smart Planner");

export const schedulerViewAnalytics = new AnalyticsService("Activity Scheduler");

export default activityTableAnalytics;
